const DO_NOT_TRANSFORM = new Set(['', '--'])

function toSentenceCaseLine(line: string): string {
  const trimmed = line.trim()
  if (DO_NOT_TRANSFORM.has(trimmed)) {
    return line
  }

  const match = /^(\s*)(\S)([\s\S]*)$/.exec(line)
  if (!match) {
    return line
  }

  const [, leading, first, rest] = match

  return `${leading}${first.toLocaleUpperCase()}${rest.toLocaleLowerCase()}`
}

export function toSentenceCase(input: string): string {
  if (!input) {
    return input
  }

  return input.split('\n').map(toSentenceCaseLine).join('\n')
}
